<p-dialog *ngIf="contact"
          header="{{ (contact.id || address.id ? 'ADD_CONTACT_DIALOG.MODIFY_HEADER' : 'ADD_CONTACT_DIALOG.NEW_HEADER') | translate }}"
          [(visible)]="display"
          [height]="685"
          [modal]="true"
          [draggable]="false">
  <form [formGroup]="contactForm" (submit)="save()">
    <div class="ui-g service-edit-dialog m-b-0 create-contact-dialog-content">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-12">
            <wsd-select-contact-type
              [includingPostAddress]="includingPostAddress"
              [parentForm]="contactForm"
              (onChange)="isChangedContactType()">
            </wsd-select-contact-type>
          </div>
          <div class="ui-g-12" *ngIf="isContactType()">
            <div class="ui-g m-b-0">
              <div class="ui-g-5">
                <label>{{ 'ADD_CONTACT_DIALOG.CONTACT_VALUE' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <gs-extended-input [control]="contactForm.get('value')">
                  <input pInputText
                         maxlength="1024"
                         formControlName="value"
                  />
                </gs-extended-input>
              </div>


              <div class="ui-g-12" [hidden]="isOrganization">
                <wsd-select-contact-visibility pTooltip="{{ 'CONTACT_VISIBILITY_TOOLTIP' | translate }} "
                  [parentForm]="contactForm">
                </wsd-select-contact-visibility>
              </div>

              <div class="ui-g-5">
                <label>{{ 'ADD_CONTACT_DIALOG.PREFERRED_CONTACT' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <p-checkbox formControlName="preferred"
                            binary="true"
                            class="m-t-10"
                            (onChange)="changeCheckBoxPreferredContact()">
                </p-checkbox>
              </div>
            </div>
          </div>
          <div *ngIf="isLocationType()">
            <div class="ui-g-5">
              <label>{{ 'WS_DIRECTORY.ORG_MODIFY.HQ_ADDRESS.ADDRESS1_LABEL' | translate }}</label>
            </div>
            <div class="ui-g-7">
              <gs-extended-input [control]="contactForm.get('address1')">
                <input pInputText formControlName="address1">
              </gs-extended-input>
            </div>
            <div class="ui-g-5">
              <label>{{ 'WS_DIRECTORY.ORG_MODIFY.HQ_ADDRESS.ADDRESS2_LABEL' | translate }}</label>
            </div>
            <div class="ui-g-7">
              <gs-extended-input [control]="contactForm.get('address2')">
                <input pInputText formControlName="address2">
              </gs-extended-input>
            </div>
            <div class="ui-g-5">
              <label>{{ 'WS_DIRECTORY.ORG_MODIFY.HQ_ADDRESS.ADDRESS3_LABEL' | translate }}</label>
            </div>
            <div class="ui-g-7">
              <gs-extended-input [control]="contactForm.get('address3')">
                <input pInputText formControlName="address3">
              </gs-extended-input>
            </div>
            <div class="ui-g-5">
              <label>{{ 'WS_DIRECTORY.ORG_MODIFY.HQ_ADDRESS.ADDRESS4_LABEL' | translate }}</label>
            </div>
            <div class="ui-g-7">
              <gs-extended-input [control]="contactForm.get('address4')">
                <input pInputText formControlName="address4">
              </gs-extended-input>
            </div>
            <div class="ui-g-5">
              <label>{{ 'WS_DIRECTORY.ORG_MODIFY.HQ_ADDRESS.CITY_LABEL' | translate }}</label>
            </div>
            <div class="ui-g-7">
              <gs-extended-input [control]="contactForm.get('addressCity')">
                <input pInputText formControlName="addressCity">
              </gs-extended-input>
            </div>
            <div class="ui-g-5">
              <label>{{ 'WS_DIRECTORY.ORG_MODIFY.HQ_ADDRESS.ZIP_LABEL' | translate }}</label>
            </div>
            <div class="ui-g-7">
              <gs-extended-input [control]="contactForm.get('addressZip')">
                <input pInputText formControlName="addressZip" type="text">
              </gs-extended-input>
            </div>
            <div class="ui-g-5">
              <label>{{ 'WS_DIRECTORY.ORG_MODIFY.HQ_ADDRESS.COUNTRY_LABEL' | translate }}</label>
            </div>
            <div class="ui-g-12" [hidden]="isOrganization">
              <wsd-select-contact-visibility pTooltip="{{ 'CONTACT_VISIBILITY_TOOLTIP' | translate }} "
                                             [parentForm]="contactForm">
              </wsd-select-contact-visibility>
            </div>
            <div class="ui-g-7">
              <wsd-select-country [parentForm]="contactForm"
                                  [controlName]="'addressCountry'"
                                  [showLabel]="false"
                                  [withInapplicable]="true"
              >
              </wsd-select-country>
            </div>
          </div>
          <div class="ui-g-5"></div>
          <div class="ui-g-7">
            <button pButton
                    label="{{ (contact.id || address.id ? 'ADD_CONTACT_DIALOG.UPDATE_BTN' : 'ADD_CONTACT_DIALOG.ADD_BTN') | translate }}"
                    class="ui-button-success">
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
